<template>
  <v-toolbar color="primary" dark fixed app clipped-left v-if="$route.name != 'Login'">
    <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
    <v-spacer></v-spacer>
    <v-toolbar-title>{{appName}}</v-toolbar-title>
    <v-spacer></v-spacer>
  </v-toolbar>
</template>
<script>
import { mapGetters } from "vuex";

export default {

  name: "Toolbar",

  computed: {
    drawer: {
      get() {
        return this.$store.state.interfaceSettings.navigationDrawer;
      },
      set(newValue) {
        this.$store.commit("interfaceSettings/SET_navigationDrawer", newValue);
      }
    },

    ...mapGetters('interfaceSettings', {
      appName: 'appName'
    })
  }
};
</script>

